// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"n3-z","displaySixCardTiles":"o3-z"};